export default "__VITE_ASSET__7f2627b5__"